// extracted by mini-css-extract-plugin
module.exports = {"sideDrawer":"SideDrawer_sideDrawer__WWofY","open":"SideDrawer_open__9Kg2o","sideDrawer_head":"SideDrawer_sideDrawer_head__QY_cm"};